import HeaderCancilleria from '../../components/headerIcetex/headerCancilleria';
import { ILayout } from '../../../shared/types/layout';

export function LayoutCancilleria({ children }: ILayout) {
    return (
        <div>
            <HeaderCancilleria />
            {children}
        </div>
    );
}
